import React from 'react'
import { Card, Table, Tag, Typography } from 'antd'
import { FormComponent } from '../../../../BaseComponent'
import { DashboardProps } from '../types'
import IIntegrationDefinitions from '../../../../../interfaces/IIntegrationDefinitions'

export default class DashboardDefinitions extends FormComponent<DashboardProps> {

  tableColumns = [
    {
      title: 'Partner',
      dataIndex: 'partner_key',
      key: 'partner_key',
      render: (text: string) => (
        <Tag color="purple">{text}</Tag>
      )
    },
    {
      title: 'Characteristic Type',
      dataIndex: 'characteristicType',
      key: 'characteristicType',
      render: (text: string) => (
        <Tag color="blue">{text}</Tag>
      )
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (text: string) => (
        <Tag color="blue">{text}</Tag>
      )
    },
    {
      title: 'Path',
      dataIndex: 'path',
      key: 'path',
      render: (text: string) => (
        <Typography.Text code>{text}</Typography.Text>
      )
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      render: (text: string) => (
        <Tag color="geekblue">{text}</Tag>
      )
    },
    {
      title: 'Global',
      dataIndex: 'global',
      key: 'global',
      render: (text: string, record: IIntegrationDefinitions) => (
        <Tag color={record.global ? 'blue' : 'cyan'}>{record.global ? 'Yes' : 'No'}</Tag>
      )
    },
  ]

  render() {
    return (
      <Card title="Definitions">
        <Table
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={this.props.context.preview?.definitions as any || []}
        />
      </Card>
    )
  }
}